import apiService from './api/api.service';

class UserService {
  async getProfile() {
    return apiService.get('/users/profile');
  }

  async updateProfile(data) {
    return apiService.put('/users/profile', data);
  }

  async changePassword(data) {
    return apiService.post('/users/change-password', data);
  }

  async uploadAvatar(file) {
    const formData = new FormData();
    formData.append('avatar', file);
    
    return apiService.post('/users/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  async deleteAccount() {
    return apiService.delete('/users/account');
  }

  async getUsers(params = {}) {
    return apiService.get('/users', { params });
  }

  async getUserById(id) {
    return apiService.get(`/users/${id}`);
  }

  async createUser(data) {
    return apiService.post('/users', data);
  }

  async updateUser(id, data) {
    return apiService.put(`/users/${id}`, data);
  }

  async deleteUser(id) {
    return apiService.delete(`/users/${id}`);
  }
}

export const userService = new UserService();
export default userService;
